import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProcessStepper from "../../../../components/stepperprocess/ProcessStepper";
import { capitalizeFirst } from "../../../../utils/commonServices";

const PersonalDetailsProcess = ({}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const company = location.state?.company;
  const userType = location.state?.userType;
  console.log("====================================");
  console.log("company TRck--->", company);
  console.log("====================================");

  if (!company) {
    return (
      <div className="container py-4">
        <p>
          No personal data found.{" "}
          <button className="btn btn-link" onClick={() => navigate(-1)}>
            Go back
          </button>
        </p>
      </div>
    );
  }

  const handleApprove = () => {
    // console.log(company)
    // return
    navigate("/kyc-process", { state: { company, userType: "Member" } });
  };

  const handleBack = () => {
    navigate(-1);
  };

  // const personal = company.personal || {};
  return (
    <div className="" style={{ minHeight: "100vh" }}>
      <div>
        <ProcessStepper currentStep={1} userType={userType} />
      </div>
      <div className="flex-grow-1">
        <div className="p-4 shadow rounded bg-white">
          <div className="d-flex">
            <div className="col-6">
              <h4>Signatory Details</h4>
              <p>
                <strong>Full Name :</strong> {capitalizeFirst(company.member_contact_name)}
              </p>
              <p>
                <strong>Designation :</strong> {company.member_designation}
              </p>
              <p>
                <strong>Email:</strong> {company.member_email}
              </p>
              <p>
                <strong>Phone:</strong> {company.member_mobile}
              </p>
              <p>
                <strong>Address:</strong>{" "}
                {company.member_city + ", " + company.member_state}
              </p>
            </div>
            <div className="col-6">
              <p style={{ fontSize: "16px" }}>Owner Image</p>
              <img
                src={
                  company.member_profile_url ||
                  "https://images.pexels.com/photos/3182761/pexels-photo-3182761.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                }
                alt="Company"
                className="img-fluid rounded shadow"
              />
            </div>
          </div>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <button
              className="btn btn-outline-secondary px-4"
              onClick={handleBack}
            >
              Back
            </button>
            <button className="btn btn-primary px-4" onClick={handleApprove}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetailsProcess;
